import React, {
    useState,
    useContext,
    useEffect,
} from 'react';

import { GameItem } from '../GameItem/GameItem';
import { SearchSectionTitle } from '../SearchSectionTitle/SearchSectionTitle';
import {
    AsgDictionaryContext,
    AsgFwContext,
    AsgAppGamesContext,
} from '../../contexts';

export const RecentGames = ({
    handleSearchOpenStatus,
    isLoggedIn,
    setHasGames = null,
}) => {
    const [recentGames, setRecentGames] = useState([]);
    const dictionary = useContext(AsgDictionaryContext);
    const AsgGames = useContext(AsgAppGamesContext);
    const AsgFw = useContext(AsgFwContext);

    const playAgainTitle = dictionary.translate('playAgain');

    const recentGamesLimit = 3;

    const updateRecentList = () => {
        if (isLoggedIn) {
            AsgFw.getRecentGames((data) => {
                getRecent(data);
            });
        } else {
            setRecentGames([]);
        }
    };

    useEffect(() => {
        updateRecentList();
        $(document).on('endInGame', updateRecentList);
        return () => {
            $(document).off('endInGame', updateRecentList);
        };
    }, []);

    const getRecent = (data) => {
        let recentGamesList = [];
        data.forEach((value) => {
            let temp = AsgGames.getGameById(value.gameId);
            if (temp) {
                recentGamesList.push(temp);
            }
        });
        setRecentGames(recentGamesList);
    };

    // Inform parent about changes.
    useEffect(() => {
        if (setHasGames) {
            setHasGames(recentGames.length > 0);
        }
    }, [recentGames]);

    if (!isLoggedIn || !recentGames.length) {
        return null;
    }

    return (<>
        <SearchSectionTitle title={playAgainTitle}/>
        {recentGames.slice(0, recentGamesLimit).map((item) => (
            <GameItem onOpenGame={() => {
                handleSearchOpenStatus(item);
            }}
            key={item.id}
            data={item}
            />
        ))
        }
    </>);
};
